import { useEffect, useState } from "react";

function diff(target) {
  const now = Date.now();
  const delta = Math.max(0, target - now);
  const days = Math.floor(delta / (1000 * 60 * 60 * 24));
  const hours = Math.floor((delta / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((delta / (1000 * 60)) % 60);
  const seconds = Math.floor((delta / 1000) % 60);
  return { days, hours, minutes, seconds, done: delta === 0 };
}

export default function CountdownTimer({ isoDate }) {
  const target = new Date(isoDate).getTime();
  const [t, setT] = useState(diff(target));

  useEffect(() => {
    const i = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(i);
  }, [target]);

  const Block = ({ value, label, testid }) => (
    <div
      className="flex-1 min-w-0 border border-white/10 bg-[#12141D] px-3 py-4 sm:py-6 text-center"
      data-testid={testid}
    >
      <div
        className="font-display text-5xl sm:text-7xl lg:text-8xl text-white glow-blue"
        style={{ color: "#00E5FF" }}
      >
        {String(value).padStart(2, "0")}
      </div>
      <div className="label-caps mt-2">{label}</div>
    </div>
  );

  return (
    <div className="grid grid-cols-4 gap-2 sm:gap-3" data-testid="countdown-timer">
      <Block value={t.days} label="Dias" testid="countdown-days" />
      <Block value={t.hours} label="Horas" testid="countdown-hours" />
      <Block value={t.minutes} label="Mins" testid="countdown-mins" />
      <Block value={t.seconds} label="Segs" testid="countdown-secs" />
    </div>
  );
}
